export const branchDisplayList = [
  { value: 20 },
  { value: 50 },
  { value: 100 },
]
